<template>
  <div>
    <video :style="{'width':config.width,'height':config.height}"
      :width="config.width"
      :height="config.height"
      :id="`videoBox_${random}`"
      :loop="config.loop"
      ref="videoBox"
      :muted="config.muted"
      :controls="config.controls"
      :controlslist="config.videoControls"></video>
  </div>
</template>
<script>
import HLS from 'hls.js'
export default {
  name: 'videoPlay',
  data() {
    return {
      /**
         * 1、nodownload: 不要下载按钮
          2、nofullscreen: 不要全屏按钮
          3、noremoteplayback: 不要远程回放
          4、disablePictureInPicture 不要画中画 按钮
          5、noplaybackrate 不要播放速度按钮
         */
      random: new Date().getTime(),
      config: {
        width: '200px',
        height: '200px',
        autoplay: false,
        loop: true,
        muted: 'muted',
        controls: true,
        controlslist: ''
      }
    }
  },
  props: {
    videoConfig: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    videoConfig: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.config = { ...this.config, ...this.videoConfig }
        }
      },
      deep: true
    }
  },
  mounted() {
    this.config = { ...this.config, ...this.videoConfig }
    this.videoPlay()
  },
  methods: {
    videoPlay() {
      if (HLS.isSupported()) {
        var videoBox = document.getElementById(`videoBox_${this.random}`);
        var hls = new HLS();
        hls.loadSource('/zwpt-file/portal/largefile/164197625/index.m3u8');
        hls.attachMedia(videoBox);
        hls.on(HLS.Events.MANIFEST_PARSED, function () {
          if (this.config.autoplay) {
            videoBox.play();
          }
        });
      }
    },
    videoPlay2() {
      var video = document.getElementById("videoBox");
      window.URL = window.URL || window.webkitURL;
      var blob = res;
      video.onload = function (e) {
        window.URL.revokeObjectURL(video.src);
      };
      video.src = window.URL.createObjectURL(blob);
    }
  }
}
</script>
<style lang="scss" scoped>
video {
  max-width: none;
}
</style>


// WEBPACK FOOTER //
// src/components/video/video.vue